import React from 'react';
import { transparentize } from 'polished';
import styled, { css } from 'styled-components';
import Image from './image';

export const Overlay = styled.div`
  position: relative;

  ${({ $darken }) => $darken && css`
    background-color: rgba(0, 0, 0, 0.3);
  `}
  ${({ $darker }) => $darker && css`
    background-color: rgba(0, 0, 0, 0.6);
  `}
  ${({ $lighten }) => $lighten && css`
    background-color: rgba(255, 255, 255, 0.3);
  `}
  ${({ $standout, theme }) => $standout && css`
    background-color: ${transparentize(theme.backgroundImageStandoutTransparency || 0.25, theme.primaryColor)};
  `}
  ${({ $fadeIn }) => $fadeIn && css`
    background: linear-gradient(to bottom, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0) 42%);
  `}
  ${({ $fadeOut }) => $fadeOut && css`
    background: linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 42%);
  `}
  ${({ $fadeInAndOut }) => $fadeInAndOut && css`
    background: linear-gradient(to bottom, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0) 42%),
                linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 42%);
  `}
  ${({ $fadeLeftToCenter }) => $fadeLeftToCenter && css`
    background: linear-gradient(to right, rgba(0,0,0,.8) 0%, rgba(0,0,0,0) 50%);
  `}
  ${({ $fadeRightToCenter }) => $fadeRightToCenter && css`
    background: linear-gradient(to left, rgba(0,0,0,.8) 0%, rgba(0,0,0,0) 50%);
  `}

`;

const BackgroundImage = ({
  className,
  src,
  image,
  children,
  darken,
  darker,
  lighten,
  standout,
  fadeIn,
  fadeOut,
  fadeInAndOut,
  fadeLeftToCenter,
  fadeRightToCenter,
  Tag = 'div',
  imagePosition,
  repeatBackground,
  ...props
}) => (
  <Tag className={className}>
    {!repeatBackground && (
      <Image
        className="background-image"
        image={image}
        {...props}
      />
    )}
    <Overlay
      $darken={darken}
      $darker={darker}
      $lighten={lighten}
      $standout={standout}
      $fadeIn={fadeIn}
      $fadeOut={fadeOut}
      $fadeInAndOut={fadeInAndOut}
      $fadeLeftToCenter={fadeLeftToCenter}
      $fadeRightToCenter={fadeRightToCenter}
    >
      {children}
    </Overlay>
  </Tag>
);

export default styled(BackgroundImage)`
  position: relative;
  ${({ $respectRatio, $fullWidth }) => $respectRatio && !$fullWidth && css`
    ${Overlay} {
      position: absolute !important;
      --background-image-overlay-padding: 0;
      left: var(--background-image-overlay-padding);
      right: var(--background-image-overlay-padding);
      top: var(--background-image-overlay-padding);
      bottom: var(--background-image-overlay-padding);
      display: flex;
      align-items: center;
      > * {
        flex-grow: 1;
      }
    }
  `}
  ${({ $respectRatio, $fullWidth, image }) => $respectRatio && $fullWidth && image && css`
    padding-top: ${(image.height / image.width) * 100}%;
  `}

  ${({ $respectRatio, $fullWidth }) => !($respectRatio && !$fullWidth) && css`
    .background-image {
      position: absolute !important;
      left:0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  `}

  ${({ $push }) => $push && css`
    .background-image {
      ${$push === 'left-half' && css`
        margin-right: 50%;
      `}
      ${$push === 'right-half' && css`
        margin-left: 50%;
      `}
    }
  `}

  ${({ repeatBackground, $backgroundSize }) => repeatBackground && css`
    background-size: ${$backgroundSize};
    background-repeat: repeat;
    background-position: top left;
    background-image: url(${({ image }) => image.url});
  `}
`;
